import { ParsedJourneyParams } from '@store/yourJourney/selectors';
import { useRoomRates } from '@features/rates';
import { toPayableAmount } from '@features/rooms/helpers/toPayableAmount.helper';

import { toRates, toRoomAvailabilityParams } from './mappers';

export default function useRates(
  roomId: string,
  journeyParams: ParsedJourneyParams,
  language?: string
) {
  const roomAvailabilityParams = toRoomAvailabilityParams(journeyParams);
  const {
    rates: roomRates,
    isFetching,
    promoRateCodeIssue,
    isAvailabilityUnknown,
    refetchAvailability,
  } = useRoomRates(roomId, roomAvailabilityParams, language);

  const rates = toRates(roomRates);

  const [lowestRate] = [...rates].sort(
    (a, b) =>
      (toPayableAmount(a.pricePerStay, a.discount) ?? 0) -
      (toPayableAmount(b.pricePerStay, b.discount) ?? 0)
  );

  return {
    rates,
    lowestRate: lowestRate?.pricePerStay ?? null,
    lowestRateDiscount: lowestRate?.discount ?? null,
    isFetching,
    promoRateCodeIssue,
    isAvailabilityUnknown,
    refetchAvailability,
  };
}
